const CloudinaryFetchBaseUrl = 'https://cms.cloudinary.vpsvc.com/image/fetch';

const FetchTransformations = {
  crop: 'c_scale',
  dpr: 'dpr_auto',
  format: 'f_auto',
  quality: 'q_auto:best',
} as const;

const buildFetchTransformation = (width: number): string => {
  const widthParam = `w_${width}`;
  return [
    FetchTransformations.crop,
    FetchTransformations.dpr,
    FetchTransformations.format,
    FetchTransformations.quality,
    widthParam,
  ].join(',');
};

export const buildCloudinaryFetchUrl = (originUrl: string, width: number): string => {
  // Pass-through for native Cloudinary URLs (e.g. those already containing a
  // `t_pdpHeroGallery` named transformation applied by CloudinaryMediaTransformer).
  // In practice, buildPreloadImageUrl only reaches this function with URLs
  // from the rendering service (rendering.mcp.cimpress.com) on ad-landing pages
  // — never with native Cloudinary URLs — so the preload URL always matches the
  // gallery <img> src. If that invariant ever breaks, the preload becomes a no-op
  // (wasted bandwidth) but causes no functional regression.
  if (originUrl.includes('cloudinary')) {
    return originUrl;
  }

  const transformation = buildFetchTransformation(width);
  const encodedUrl = encodeURIComponent(originUrl);

  return `${CloudinaryFetchBaseUrl}/${transformation}/${encodedUrl}`;
};
